'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $tenant = process.env.ELECTRODE_TENANT;
var tenantMessages = void 0;

try {
	tenantMessages = require('./tenants/' + $tenant + '/default-messages'); //eslint-disable-line
} catch (err) {
	tenantMessages = {};
}

var messages = (0, _reactIntl.defineMessages)({
	ACCEPTABLE_USE_POLICY: {
		'id': 'FOOTER.ACCEPTABLE_USE_POLICY',
		'defaultMessage': 'Acceptable Use Policy'
	},
	BLOG_TITLE: {
		'id': 'FOOTER.BLOG_TITLE',
		'defaultMessage': 'Read our latest blog posts'
	},
	CAREERS: {
		'id': 'FOOTER.CAREERS',
		'defaultMessage': 'Careers'
	},
	CONTACT: {
		'id': 'FOOTER.CONTACT',
		'defaultMessage': 'Contact'
	},
	CONTACT_US: {
		'id': 'FOOTER.CONTACT_US',
		'defaultMessage': 'Contact us'
	},
	COOKIE_POLICY: {
		'id': 'FOOTER.COOKIE_POLICY',
		'defaultMessage': 'Cookie Policy'
	},
	FACEBOOK_TITLE: {
		'id': 'FOOTER.FACEBOOK_TITLE',
		'defaultMessage': 'Like your find a doctor specialists on Facebook'
	},
	FAQS_FOR_PATIENTS: {
		'id': 'FOOTER.FAQS_FOR_PATIENTS',
		'defaultMessage': 'FAQs (for patients)'
	},
	FIND_A_DOCTOR: {
		'id': 'FOOTER.FIND_A_DOCTOR',
		'defaultMessage': 'Doctify, your Find a Doctor specialist'
	},
	FIND_A_DOCTOR_ALT: {
		'id': 'FOOTER.FIND_A_DOCTOR_ALT',
		'defaultMessage': 'Your Find A Doctor Specialist | Doctify'
	},
	GETTING_STARTED: {
		'id': 'FOOTER.GETTING_STARTED',
		'defaultMessage': 'Getting Started'
	},
	GOOGLE_PLUS_TITLE: {
		'id': 'FOOTER.GOOGLE_PLUS_TITLE',
		'defaultMessage': 'Plus one us on Google Plus'
	},
	INSTAGRAM_TITLE: {
		'id': 'FOOTER.INSTAGRAM_TITLE',
		'defaultMessage': 'Share your find a doctor specialists on Instagram'
	},
	JOIN_DOCTIFY: {
		'id': 'FOOTER.JOIN_DOCTIFY',
		'defaultMessage': 'Join Doctify'
	},
	LEARN_ABOUT_DOCTIFY: {
		'id': 'FOOTER.LEARN_ABOUT_DOCTIFY',
		'defaultMessage': 'Learn about Doctify'
	},
	LINKED_IN_TITLE: {
		'id': 'FOOTER.LINKED_IN_TITLE',
		'defaultMessage': 'Share your find a doctor specialists on LinkedIn'
	},
	MISSION: {
		'id': 'FOOTER.MISSION',
		'defaultMessage': 'Mission'
	},
	LEGAL: {
		'id': 'FOOTER.LEGAL',
		'defaultMessage': 'Legal'
	},
	PRESS: {
		'id': 'FOOTER.PRESS',
		'defaultMessage': 'Press'
	},
	PRIVACY_POLICY: {
		'id': 'FOOTER.PRIVACY_POLICY',
		'defaultMessage': 'Privacy Policy'
	},
	SOCIAL_MEDIA: {
		'id': 'FOOTER.SOCIAL_MEDIA',
		'defaultMessage': 'Social media'
	},
	SOCIAL_MEDIA_AND_JOURNAL: {
		'id': 'FOOTER.SOCIAL_MEDIA_AND_JOURNAL',
		'defaultMessage': 'Social Media & Journal'
	},
	TERMS_AND_CONDITIONS: {
		'id': 'FOOTER.TERMS_AND_CONDITIONS',
		'defaultMessage': 'Terms & conditions'
	},
	TWITTER_TITLE: {
		'id': 'FOOTER.TWITTER_TITLE',
		'defaultMessage': 'Tweet your find a doctor specialists on Twitter'
	}
});

module.exports = (0, _assign2.default)({}, messages, tenantMessages);


// WEBPACK FOOTER //
// ./components/footer/lib/lang/default-messages.js